// Injected by webpack (see webpack.config.js): localhost in dev, Azure in prod.
const API_BASE_URL = process.env.ARCHIVE_API_BASE_URL;
const ADDIN_API_KEY = process.env.ADDIN_API_KEY;

function apiHeaders(extra = {}) {
  return {
    "Content-Type": "application/json",
    ...(ADDIN_API_KEY ? { "X-API-Key": ADDIN_API_KEY } : {}),
    ...extra,
  };
}

function formatDetails(details) {
  if (details === undefined || details === null) {
    return "";
  }
  if (typeof details === "string") {
    return details;
  }
  try {
    return JSON.stringify(details);
  } catch {
    return String(details);
  }
}

function messageFromErrorBody(status, body) {
  if (body && typeof body === "object") {
    const main = body.error || body.message || "";
    const extra = formatDetails(body.details);
    if (main && extra && extra !== main) {
      return `${main}: ${extra}`;
    }
    if (main) {
      return main;
    }
    if (extra) {
      return extra;
    }
  }
  if (typeof body === "string" && body.trim()) {
    return body.trim();
  }
  return `Request failed (${status})`;
}

async function throwIfNotOk(response) {
  if (response.ok) {
    return;
  }

  const raw = await response.text();
  let body = null;
  if (raw) {
    try {
      body = JSON.parse(raw);
    } catch {
      body = raw;
    }
  }

  const message = messageFromErrorBody(response.status, body);
  const err = new Error(message);
  err.status = response.status;
  err.body = body;

  console.error("[archiveApi]", response.status, response.url || "", body ?? raw);

  throw err;
}

export async function processEmail({ emailId, userEmail, projectId, previewText }) {
  const response = await fetch(`${API_BASE_URL}/api/process-email`, {
    method: "POST",
    headers: apiHeaders(),
    body: JSON.stringify({ emailId, userEmail, projectId, previewText }),
  });

  await throwIfNotOk(response);
  return response.json();
}

export async function lookupProject(projectId) {
  const query = `?projectId=${encodeURIComponent(projectId)}`;
  const response = await fetch(`${API_BASE_URL}/api/projects/lookup${query}`, {
    headers: apiHeaders(),
  });

  await throwIfNotOk(response);
  return response.json();
}

export async function searchProjects(search) {
  const query = `?search=${encodeURIComponent(search)}`;
  const response = await fetch(`${API_BASE_URL}/api/projects/lookup${query}`, {
    headers: apiHeaders(),
  });

  await throwIfNotOk(response);
  return response.json();
}

export async function repairEmailBody({ emailId, userEmail, internetMessageId, theme }) {
  const response = await fetch(`${API_BASE_URL}/api/repair-email-body`, {
    method: "POST",
    headers: apiHeaders(),
    body: JSON.stringify({ emailId, userEmail, internetMessageId, theme }),
  });

  await throwIfNotOk(response);
  return response.json();
}

export async function getSubscriptionSettings(userEmail) {
  const query = userEmail ? `?userEmail=${encodeURIComponent(userEmail)}` : "";
  const response = await fetch(`${API_BASE_URL}/api/subscription-settings${query}`, {
    headers: apiHeaders(),
  });

  await throwIfNotOk(response);
  return response.json();
}

export async function updateSubscriptionSettings({ enabled, userEmail }) {
  const response = await fetch(`${API_BASE_URL}/api/subscription-settings`, {
    method: "PUT",
    headers: apiHeaders(),
    body: JSON.stringify({ enabled, userEmail }),
  });

  await throwIfNotOk(response);
  return response.json();
}
